export default __webpack_public_path__ + "static/microservice-292d98570fe7887b224841916d373e02.png";